import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Admin/Sidebar'
import * as Icon from 'react-bootstrap-icons'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import InputGroup from 'react-bootstrap/InputGroup';
import Spinner from 'react-bootstrap/Spinner';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';

const SoldProducts = () => {
    const [toggleValue, setToggleValue] = useState(false)
    const [show, setShow] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [productToUpdate, setProductToUpdate] = useState(null)
    const navigate = useNavigate();

    // Updateble data
    const [productId, setProductId] = useState()
    const [productTitle, setProductTitle] = useState()
    const [productPrice, setProductPrice] = useState()
    const [productSku, setProductSku] = useState()
    const [productStock, setProductStock] = useState()
    const [productDescription, setProductDescription] = useState()
    const [productStatus, setProductStatus] = useState('')
    const [products, setProducts] = useState([])
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('')

    const [newSubcategory, setNewSubcategory] = useState('')
    const [orderstatus, setOrderstatus] = useState([]);

    // Authentication
    const authtoken = localStorage.getItem('token');
    const token = `Bearer ${authtoken}`;

    const getData = async (token) => {
        const response = await getProducts(token);
        setProductStatus(response?.status)
        setProducts(response?.products)
    }

    useEffect(() => {
        getData(token);
    }, [token])

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleUpdateClose = () => setShowUpdate(false);
    const handleDeleteClose = () => { setShowDelete(false); setProductId('') };


    useEffect(() => {

        const getCategories = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}product/categories`);
                setCategories(response.data.categories)
            } catch (error) {
                console.error('Error:', error);
            }
        }

        getCategories()

    }, [])


    const getSubCategories = async (category) => {

        const categoryId = JSON.parse(category).id
        const categoryName = JSON.parse(category).name

        setSelectedCategory(categoryId)
        try {

            const response = await axios.get(`${process.env.REACT_APP_API_URL}product/subcategories?categoryname=${categoryName}`)
            setSubCategories(response.data.subcategories);

        } catch (error) {
            console.error("Error: " + error)
        }
    }

    const handleImageClick = () => {
        document.getElementById('mainImageInput').click();
    };

    const [productData, setProductData] = useState({
        mainImage: null,
        productName: '',
        price: '',
        sku: '',
        stock: 1,
        description: '',
        gallery: [null, null, null],
    });

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {
            setProductData({
                ...productData,
                [name]: files[0]
            });
        } else {
            setProductData({
                ...productData,
                [name]: value
            });
        }
    };

    const handleGalleryChange = (index, file) => {
        const updatedGallery = [...productData.gallery];
        updatedGallery[index] = file;
        setProductData({
            ...productData,
            gallery: updatedGallery
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        const images = [productData.mainImage, ...productData.gallery];

        images.forEach((file) => {
            if (file) {
                formData.append(`images`, file);
            }
        });

        if (productData.productName === '' || productData.price === '' || productData.sku === '' || productData.description === '') {
            toast.error("Please complete product details!");
            return;
        }


        if (selectedCategory === '' && newSubcategory === '') {
            toast.warn("Select category and subcategory!");
            return;
        }

        formData.append('title', productData.productName);
        formData.append('price', productData.price);
        formData.append('sku', productData.sku);
        formData.append('stockQty', productData.stock);
        formData.append('description', productData.description);
        formData.append('categories', selectedCategory);
        formData.append('subcategories', newSubcategory);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}product/add`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': token
                }
            });

            const message = response.data.message;
            const status = response.data.status;

            if (status === "error") {
                toast.warn(message);
            } else {
                toast.success("Product successfully uploaded");
                getData(token)
            }
        } catch (error) {
            toast.error('Error:', error);
        }
    };

    const handleUpdateShow = (product) => {
        setProductToUpdate(product);
        setProductId(product.id)
        setProductTitle(product.title)
        setProductPrice(product.price)
        setProductSku(product.sku)
        setProductStock(product.stockQty)
        setProductDescription(product.description)
        setShowUpdate(true);
    }
    const handleDeleteShow = (productId) => {
        setProductId(productId)
        setShowDelete(true);
    }

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        // Update logic goes here
        formData.append('id', productId);
        formData.append('title', productTitle);
        formData.append('price', productPrice);
        formData.append('sku', productSku);
        formData.append('stockQty', productStock);
        formData.append('description', productDescription);

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}product/update`, formData, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'multipart/form-data',
                },
            });

            const message = response.data.message;
            const status = response.data.status;

            if (status === "error") {
                toast.warn(message);
            } else {
                toast.success("Product successfully updated");
                // getData()
                getData(token)
            }
        } catch (error) {
            toast.error('Error:', error);
        }

        handleUpdateClose();
    };




    const handleDeleteSubmit = async () => {

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}product/delete`, { id: productId }, {
                headers: {
                    Authorization: token,
                    'Content-Type': 'application/json',
                },
            });

            const message = response.data.message;
            const status = response.data.status;

            if (status === "error") {
                toast.warn(message);
            } else {
                toast.success(message);
                // getData()
                getData(token);
                getDataBySeller();
            }

        } catch (error) {
            toast.error('Error:', error);
        }

        handleDeleteClose()
    }

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/login');
        }
    }, [navigate]);



    const handleProductStatusChnge = async (productId, orderType, orderId) => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}order/updateOrderType`,
                { productId: productId, orderType, orderId },
                {
                    headers: {
                        Authorization: token, // JWT token
                        'Content-Type': 'application/json',
                    },
                }
            );

            const message = response.data.message;
            const status = response.data.status;

            if (status === "error") {
                toast.warn(message);
            } else {
                toast.success(message);
                // getData(token); // Refresh data after success
                getDataBySeller();
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        }
    };

    useEffect(() => {
        getDataBySeller();
    }, [])


    const getDataBySeller = async () => {

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}order/getOrdersBySeller`,
                {
                    headers: {
                        Authorization: token, // JWT token
                        'Content-Type': 'application/json',
                    },
                }
            );
            setOrderstatus(response.data.orders);
        } catch (err) {
            console.error("Error for product ID:", productId, err);
        }

    };


    // defaultValue = "pending" 



    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-2 p-0">
                        <Sidebar toggleSidebar={toggleValue} setToggleValue={setToggleValue} />
                    </div>
                    <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-0 mt-md-3 mt-3 dashboard-wrapper">
                        <Icon.ArrowRight onClick={() => setToggleValue(true)} className='my-5 sidebar-open' color='black' size={30}></Icon.ArrowRight>
                        <div className='row dashboard-content mt-lg-0 mt-md-3 mt-3'>
                            <div className="col-12">
                                <h5>Sold Products</h5>

                                {
                                    products?.length > 0
                                        ?
                                        <h6 className='text-muted'>View & manage products</h6>
                                        :
                                        <h6 className='text-muted'></h6>
                                }
                            </div>
                            <div className='col-12 my-5'>
                                <div className='row'>
                                    <div className='col-lg-10 col-md-8 col-6'>
                                        {/* <Button variant="success"  onClick={handleShow}>Add product<Icon.PlusCircle className='ms-2' /></Button> */}
                                    </div>
                                    <div className='col-lg-2 col-md-4 col-6'>
                                        {/* <Form.Control
                                            type="text"
                                            placeholder="Search products"
                                            className=" mr-sm-2 shadow-none"
                                        /> */}
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <Table striped bordered hover responsive="md">
                                        <thead>
                                            <tr>
                                                {orderstatus?.length > 0 ?
                                                    <>
                                                        <th>ID</th>
                                                        <th>Image</th>
                                                        <th style={{ width: "250px" }}>Name</th>
                                                        <th>SKU</th>
                                                        <th>Price</th>
                                                        <th>Stock</th>
                                                        <th>Sold</th>
                                                        {/* <th>Actions</th> */}
                                                        <th>Order Status</th>
                                                        <th>Return Status</th>
                                                    </>
                                                    : ""
                                                }


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                orderstatus?.length > 0
                                                    ? orderstatus.map((order, i) => {
                                                        const product = order.product; // Access the product nested inside the order

                                                        return (
                                                            <tr key={i}>
                                                                <td>{parseInt(i) + 1}</td>
                                                                <td>
                                                                    <img
                                                                        className="order-list-product-image"
                                                                        src={product.image?.length > 0
                                                                            ? `${process.env.REACT_APP_API_URL}upload/product/${product.image[0]}`
                                                                            : "https://upload.wikimedia.org/wikipedia/commons/9/92/No_Preview_1.jpg"}
                                                                        alt=""
                                                                    />
                                                                </td>
                                                                <td>{product.title}</td>
                                                                <td>{product.sku}</td>
                                                                <td>{product.price}</td>
                                                                <td>{product.stockQty}</td>
                                                                <td>{product.orderQty}</td>

                                                                <td>
                                                                    <select
                                                                        onChange={(e) => handleProductStatusChnge(product.id, e.target.value, order.id)}
                                                                        // value={order.orderType ? order.orderType : "initiate"} 
                                                                        value={order.product.orderStatus ? order.product.orderStatus : "initiate"}
                                                                        style={{ width: "100%", padding: "5px", backgroundColor: "white" }}
                                                                    >
                                                                        <option value="initiate">initiate</option>
                                                                        <option value="Payment Received">Payment Received</option>
                                                                        <option value="shipped">shipped</option>
                                                                        <option value="success">success</option>
                                                                        <option value="delivered">delivered</option>
                                                                        <option value="cancelled">cancelled</option>
                                                                        <option value="Return Requested">Return Requested</option>
                                                                        <option value="Return Approved">Return Approved</option>
                                                                        <option value="Return Cancelled">Return Cancelled</option>


                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <p className='my-2'>
                                                                        <span className='text-bg-success fw-bold px-2 py-1 rounded'>{product.returnStatus ? product.returnStatus : "pending"}</span>
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                    :
                                                    <td colSpan="8" className="text-center p-5">
                                                        <p>Your Product is Not Yet Sold</p>
                                                    </td>

                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>







            {/* Add Product Modal */}
            <Modal show={show} onHide={handleClose} size="lg">
                <form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title><Icon.Bag color='black' size={40} /></Modal.Title>
                    </Modal.Header>



                    <Modal.Body>
                        <div className='row'>
                            <div className="col-lg-4 mb-lg-0 mb-md-3 mb-3">
                                <div className="image-wrapper rounded p-2" onClick={handleImageClick}>
                                    <img src={productData.mainImage ? URL.createObjectURL(productData.mainImage) : `${process.env.PUBLIC_URL}/assets/dummy.png`} className='product-image w-100' alt="" />
                                    <input
                                        type="file"
                                        id="mainImageInput"
                                        className='d-none'
                                        name="mainImage"
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <FloatingLabel controlId="floatingInput" label="Product Name" className="mb-3">
                                    <Form.Control
                                        type="text"
                                        className='shadow-none'
                                        placeholder="product name"
                                        name="productName"
                                        value={productData.productName}
                                        onChange={handleInputChange}
                                    />
                                </FloatingLabel>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text id="price"><Icon.CurrencyRupee /></InputGroup.Text>
                                    <Form.Control
                                        placeholder="Price"
                                        aria-describedby="price"
                                        className='shadow-none'
                                        name="price"
                                        value={productData.price}
                                        onChange={handleInputChange}
                                    />
                                </InputGroup>
                                <FloatingLabel controlId="floatingInput" label="" className="mb-3">
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text id="sku" className="skucss">SKU</InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            className='shadow-none'
                                            placeholder="SKU"
                                            name="sku"
                                            value={productData.sku}
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                </FloatingLabel>
                                <FloatingLabel controlId="floatingInput" label="" className="mb-3">
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text id="stock" className="skucss">stock</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            value={productData.stock}
                                            className='shadow-none'
                                            placeholder="Stock"
                                            name="stock"
                                            onChange={handleInputChange}
                                        />
                                    </InputGroup>
                                </FloatingLabel>
                            </div>
                            <div className='col-12 mb-3'>
                                {/* <FloatingLabel controlId="floatingTextarea2" label="Description"> */}
                                <FloatingLabel controlId="floatingTextarea2">

                                    {/* <Form.Control
                                        as="textarea"
                                        placeholder="Description"
                                        style={{ height: '100px' }}
                                        className='shadow-none'
                                        name="description"
                                        value={productData.description}
                                        onChange={handleInputChange}
                                    /> */}
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={productData.description}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            handleInputChange({
                                                target: {
                                                    name: 'description',
                                                    value: data
                                                }
                                            });
                                        }}
                                        config={{
                                            // Add any additional configuration if required
                                            placeholder: 'Enter product description...',
                                        }}
                                    />
                                </FloatingLabel>
                            </div>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Select aria-label="Default select example" onChange={(e) => getSubCategories(e.target.value)}>
                                            <option selected disabled>Select a category</option>
                                            {
                                                categories.map((category) => (
                                                    <option key={category.id} value={JSON.stringify(category)}>{category.name}</option>
                                                ))
                                            }
                                        </Form.Select>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Select aria-label="Default select example" onChange={(e) => setNewSubcategory(e.target.value)} >
                                            <option selected disabled>Select a category</option>
                                            {
                                                selectedCategory === ''
                                                    ?
                                                    <option className='text-muted' disabled>Select a category first</option>
                                                    :
                                                    subCategories.map((subcategory, i) => (
                                                        <option key={i} value={subcategory.id} className='d-flex justify-content-between'>{subcategory.name}</option>
                                                    ))
                                            }
                                        </Form.Select>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0 mt-3 border-top border-1'>
                                <p className='text-muted mt-2'>Gallery</p>
                                <div className="col-lg-4">
                                    <Form.Group controlId="formFileSm" className="mb-3">
                                        <Form.Label>1st image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            size="sm"
                                            className='shadow-none'
                                            onChange={(e) => handleGalleryChange(0, e.target.files[0])}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                    <Form.Group controlId="formFileSm" className="mb-3">
                                        <Form.Label>2nd image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            size="sm"
                                            className='shadow-none'
                                            onChange={(e) => handleGalleryChange(1, e.target.files[0])}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-lg-4">
                                    <Form.Group controlId="formFileSm" className="mb-3">
                                        <Form.Label>3rd image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            size="sm"
                                            className='shadow-none'
                                            onChange={(e) => handleGalleryChange(2, e.target.files[0])}
                                        />
                                    </Form.Group>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className=''>
                        <Button variant="success" type="submit" className='shadow-none' onClick={handleClose}>
                            Add product
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>














            {/* Update Product Modal */}
            <Modal show={showUpdate} onHide={handleUpdateClose} size="lg">
                <form onSubmit={handleUpdateSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title><Icon.PencilSquare color='black' size={40} /></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {productToUpdate && (
                            <div className='row'>
                                <div className="col-lg-4 mb-lg-0 mb-md-3 mb-3">
                                    <div className="image-wrapper rounded p-2">
                                        <img src={`${productToUpdate.image.length > 0 ? process.env.REACT_APP_API_URL + 'upload/product/' + productToUpdate.image[0] : "https://upload.wikimedia.org/wikipedia/commons/9/92/No_Preview_1.jpg"}`} className='product-image w-100' alt="" />
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <FloatingLabel controlId="floatingInput" label="Product Name" className="mb-3">
                                        <Form.Control
                                            type="text"
                                            className='shadow-none'
                                            placeholder="product name"
                                            name="productName"
                                            defaultValue={productToUpdate.title}
                                            onChange={(e) => setProductTitle(e.target.value)}
                                        />
                                    </FloatingLabel>
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text id="price"><Icon.CurrencyRupee /></InputGroup.Text>
                                        <Form.Control
                                            placeholder="Price"
                                            aria-describedby="price"
                                            className='shadow-none'
                                            name="price"
                                            defaultValue={productToUpdate.price}
                                            onChange={(e) => setProductPrice(e.target.value)}
                                        />
                                    </InputGroup>
                                    <FloatingLabel controlId="floatingInput" label="" className="mb-3">

                                        <InputGroup className="mb-3">
                                            <InputGroup.Text id="sku" className="skucss">SKU</InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                className='shadow-none'
                                                placeholder="SKU"
                                                name="sku"
                                                defaultValue={productToUpdate.sku}
                                                onChange={(e) => setProductSku(e.target.value)}
                                            />
                                        </InputGroup>
                                    </FloatingLabel>
                                    <FloatingLabel controlId="floatingInput" label="" className="mb-3">
                                        <InputGroup className="mb-3">
                                            <InputGroup.Text id="stock" className="skucss">stock</InputGroup.Text>

                                            <Form.Control
                                                type="number"
                                                defaultValue={productToUpdate.stockQty}
                                                className='shadow-none'
                                                placeholder="Stock"
                                                name="stock"
                                                onChange={(e) => setProductStock(e.target.value)}
                                            />
                                        </InputGroup>
                                    </FloatingLabel>
                                </div>
                                <div className='col-12'>
                                    {/* <FloatingLabel controlId="floatingTextarea2" label="Description"> */}
                                    <FloatingLabel controlId="floatingTextarea2">
                                        {/* <Form.Control
                                            as="textarea"
                                            placeholder="Description"
                                            style={{ height: '100px' }}
                                            className='shadow-none'
                                            name="description"
                                            defaultValue={productToUpdate.description}
                                            onChange={(e) => setProductDescription(e.target.value)}
                                        /> */}
                                        <Form.Group className='col-12 mb-3'>
                                            <CKEditor
                                                editor={ClassicEditor}
                                                data={productToUpdate.description}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setProductDescription(data);
                                                }}
                                                config={{
                                                    placeholder: 'Enter product description...',
                                                }}
                                            />
                                        </Form.Group>



                                    </FloatingLabel>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer className=''>
                        <Button variant="success" type="submit" className='shadow-none'>
                            Update product
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
















            {/* Delete Product Modal */}
            <Modal show={showDelete} onHide={handleDeleteClose}>
                <Modal.Header closeButton>
                    <Modal.Title><Icon.Trash3 color='black' size={40} /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='container p-3 text-center'>
                        <h5>Are you sure to delete this product?</h5>
                        <button onClick={handleDeleteSubmit} className='btn btn-danger mt-3'>Delete</button>
                    </div>
                </Modal.Body>
            </Modal>





            <ToastContainer theme="dark" autoClose={2000} />
        </>
    )
}

export default SoldProducts

export const getProducts = async (token) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}product`, {
            headers: {
                Authorization: token,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error:', error);
    }
}

